import { Table } from '@equinor/eds-core-react'
import { ComponentSecretStatusBadge } from '../../../status-badges'
import { useSortedSecrets } from '../useSortedSecrets'
import { EditSecretButton } from './edit-secret-button/EditSecretButton'
import type { SecretTableProps } from './secretTables.types'
import { getSecretDisplayName } from './secretTables.utils'

export const GenericSecretsTable = (props: SecretTableProps) => {
  const { appName, envName, componentName, secrets } = props

  const sortedSecrets = useSortedSecrets(secrets, 'ascending')

  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <Table.Cell width={40} />
          <Table.Cell>Name</Table.Cell>
          <Table.Cell width={150}>Status</Table.Cell>
          <Table.Cell width={24} />
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {sortedSecrets.map((secret) => (
          <Table.Row key={secret.name}>
            <Table.Cell className="fitwidth padding-right-0" />
            <Table.Cell>{getSecretDisplayName(secret)}</Table.Cell>
            <Table.Cell>
              <ComponentSecretStatusBadge status={secret.status} />
            </Table.Cell>
            <Table.Cell>
              <EditSecretButton appName={appName} componentName={componentName} envName={envName} secret={secret} />
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  )
}
